import invariant from 'tiny-invariant'

import { Currency } from '../currency'
import { NativeCurrency } from '../NativeCurrency'
import { Token, WNATIVE } from '../token'


export class APE extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'APE', 'Ape Chain')
  }

  public get wrapped(): Token {
    const wnative = WNATIVE[this.chainId]
    invariant(!!wnative, 'WRAPPED')
    return wnative
  }

  private static _cache: { [chainId: number]: APE } = {}

  public static onChain(chainId: number): APE {
    return this._cache[chainId] ?? (this._cache[chainId] = new APE(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
